import React from 'react';
import { AlertCircle, Loader2 } from 'lucide-react';
import FormInput from '../../FormInput';

const RoleForm = ({
  formData,
  formErrors,
  onInputChange,
  onSubmit,
  submitting,
  selectedRole,
  onCancel
}) => {
  return (
    <form onSubmit={onSubmit} className="space-y-6">
      <div className="space-y-4">
        <FormInput
          label="Nom du rôle"
          name="name"
          type="text"
          value={formData.name}
          onChange={onInputChange}
          error={formErrors.name}
          placeholder="Ex: Administrateur, Enseignant, Étudiant..."
          required
        />

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Description (optionnel)
          </label>
          <textarea
            name="description"
            value={formData.description || ''}
            onChange={onInputChange}
            rows={3}
            className="w-full px-3 py-2 border border-gray-300 rounded-md focus:ring-[#202654] focus:border-[#202654] sm:text-sm"
            placeholder="Description du rôle et de ses responsabilités..."
          />
          {formErrors.description && (
            <p className="mt-1 text-sm text-red-600">{formErrors.description}</p>
          )}
        </div>
      </div>

      {/* Note sur les permissions */}
      <div className="bg-blue-50 border border-blue-200 rounded-md p-4">
        <div className="flex">
          <AlertCircle className="h-5 w-5 text-blue-400 mr-2 flex-shrink-0 mt-0.5" />
          <div className="text-sm">
            <p className="text-blue-800 font-medium">Attribution des permissions</p>
            <p className="text-blue-700 mt-1">
              Les permissions spécifiques seront attribuées après la création du rôle 
              via la section "Gestion des Permissions".
            </p>
          </div>
        </div>
      </div>

      {/* Boutons */}
      <div className="flex justify-end space-x-3 pt-6 border-t">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654]"
        >
          Annuler
        </button>
        <button
          type="submit"
          disabled={submitting}
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#202654] hover:bg-[#1a1f45] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#202654] disabled:opacity-50"
        >
          {submitting ? (
            <>
              <Loader2 className="h-4 w-4 mr-2 animate-spin inline" />
              Enregistrement...
            </>
          ) : (
            selectedRole ? 'Modifier' : 'Créer'
          )}
        </button>
      </div>
    </form>
  );
};

export default RoleForm; 